<template>
    <v-card flat class="mb-3">
            <v-layout row wrap>
                <v-flex xs12 lg8 offset-lg2>
                    <v-card flat class="mt-3 pa-1" v-if="inputData">
                        <v-form ref="form">
                            <v-flex xs12 >
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="serialNr"
                                                label="Konteinera Nr"
                                                color="deep-purple accent-3"
                                                :rules="formRules"
                                                required
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="company"
                                                color="deep-purple accent-3"
                                                item-text="name"
                                                item-value="id"
                                                :items="inputData.companies"
                                                label="Īpašnieks"
                                        ></v-autocomplete>

                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="volume"
                                                label="Tilpums"
                                                type="number"
                                                color="deep-purple accent-3"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="year"
                                                label="Ražošanas gads"
                                                type="number"
                                                color="deep-purple accent-3"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-layout row wrap>
                                <v-flex xs12 class="mx-3 mb-3">
                                    <div class="text-xs-center text-md-right">
                                        <v-btn small flat @click="hideAddContainerForm" dark color="deep-orange lighten-1">
                                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                                            <v-icon dark right>check_circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "add-container",
        data: () => ({
            serialNr: '',
            company: '',
            year: '',
            volume: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        mounted() {
            this.$store.dispatch('getContainerInputData')
        },
        computed: {
            ...mapGetters({
                inputData: 'containerInputData'
            })
        },
        methods: {
            hideAddContainerForm(){
                this.$store.dispatch('hideAddContainerForm')
            },
            submit() {
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewContainer', {
                        serialNr: this.serialNr,
                        company: this.company,
                        year: this.year,
                        volume: this.volume
                    })
                    this.$parent.snackbar = true
                    this.$parent.color = 'green'
                    this.$parent.text = 'Konteiners pievienots'
                } else {
                    this.$Progress.fail()
                }
            }
        }
    }
</script>

<style scoped>

</style>